import React, { useState } from 'react';
import { useEdit } from '../../Services/EditContext';
import { FormValue } from './FormLabel';
import { Label } from 'reactstrap';
import { authEndpoints } from '../../utils/Constants';
import { getIn, useFormikContext } from 'formik';

import ErrorMessage from '../Form/ErrorMessage';
import AsyncCreatableSelect  from 'react-select/async-creatable';
import SupplierLocationSelector from './SupplierLocationSelector';
import useFetchSimple from '../../Services/useFetchSimple';
const Selector = ({ id, ...rest }) => {
    const { touched, errors } = useFormikContext();
    const invalid = getIn(errors, id) && getIn(touched, id);
    const style = invalid ? { borderColor: 'red' } : null
    return <AsyncCreatableSelect id={id} styles={{
        control: provided => ({ ...provided, ...style }),
        // Fixes the overlapping problem of the component
        menu: provided => ({ ...provided, zIndex: 9999 })
    }} {...rest} />
}


const AirportLookup = ({ id, stateId,altStateId, newStateId, dropDownLabel,...props }) => {
    const { values, setFieldValue } = useFormikContext();
    const [edit] = useEdit();
    const fetch = useFetchSimple(); 
    const value = getIn(values, id);
    const stateValue = stateId ? getIn(values, stateId) : "";
    const newState = getIn(values, newStateId);
    const [selectedOption, setSelectdOption] = useState({ value: value, label: value });
    const handleInputChange = (place, meta) => {
        if (place && meta.action === "input-change") {
            setSelectdOption([place])
        }
    };

    const doAutoComplete = async (input, callback) => {
        const { body } = await fetch(authEndpoints.airportLookup + input);
        const options = body.map(prediction => ({
            value: prediction.site,
            label: prediction.site,
            state: prediction.state,
            altState: prediction.altState

        }));
        callback(options);
    };
 
    const onSelectChange = (c, meta) => {
        if (meta.action === "create-option") {
            stateId && setFieldValue(stateId, null);
            setFieldValue(id, c.value ? c.value.toUpperCase() : '');
            setFieldValue(newStateId, true);
            setFieldValue(altStateId, null);
        }
        else {
            setFieldValue(id, c.value);
            stateId && setFieldValue(stateId, c.state);
            altStateId && setFieldValue(altStateId, c.altState);
            newStateId && setFieldValue(newStateId, false);
        }
    }
    return (<React.Fragment>
        {edit ? <Selector
            id={id}
            defaultValue={{ value, label: value }}
            defaultOptions={[{ value: null, label: dropDownLabel ? dropDownLabel:'Please Select' }]}
            loadOptions={doAutoComplete}
            defaultInputValue={selectedOption.label}
            onInputChange={handleInputChange}
            onChange={onSelectChange}
            formatCreateLabel={(x) => <Label >Use {x}</Label>}
            options={selectedOption}  {...props}
        /> : <FormValue>{selectedOption.label}</FormValue>}
        <ErrorMessage name={id} />

        {edit && newState ? <SupplierLocationSelector id={stateId} label={'State'} showError={false} /> : <FormValue>{stateValue}</FormValue>}
        <ErrorMessage name={stateId} />

    </React.Fragment>
    );
};

export default AirportLookup;


